import { defineComponent, h } from 'vue';
import NotificationLink from '@/components/notifications/NotificationLink.vue';

// создает заголовок уведомления в зависимости от его типа
const NotificationPreviewTitle = defineComponent({
  name: 'notification-preview-title', 
  // mounted() {
  //   console.log('NotificationPreviewTitle component is mounted');
  //   console.log('Received notificationData:', this.notificationData);
  // },
  props: {
    notificationData: {
      type: Object,
      required: true,
    },
  },
  components: {
    NotificationLink,
  },
  render() {

    switch (this.notificationData.type) {
      case 1:
        return h('div', { class: 'notification__title' }, [
          h(NotificationLink, {
              linkData: this.notificationData.model.invitedBy,
              section: 'UserProfile',
          }),
          h(
            'router-link',
            {
              class: 'notification-link',
              to: { name: 'Invitations', query: { tab: 'events' } },
            },
            ' invited you ',
          ),
          ' to the event ',
          h(NotificationLink, {
              linkData: this.notificationData.model.event,
              section: 'EventPage',
          }),
          ':',
        ]);

      case 2:
        return h('div', { class: 'notification__title' }, [
          'New application to the event ',
          h(NotificationLink, {
              linkData: this.notificationData.model.event,
              section: 'EventPage',
          }),
          ' from ',
          h(NotificationLink, {
              linkData: this.notificationData.model.user,
              section: 'UserProfile',
          }),
          ':',
        ]);

      case 3:
        return h('div', { class: 'notification__title' }, [
          'Status of your application to the event ',
          h(NotificationLink, {
              linkData: this.notificationData.model.event,
              section: 'EventPage',
          }),
          ' has been changed',
        ]);

      case 4:
        return h('div', { class: 'notification__title' }, [
          h(NotificationLink, {
              linkData: this.notificationData.model.user,
              section: 'UserProfile',
          }),
          ' has joined to the event ',
          h(NotificationLink, {
              linkData: this.notificationData.model.event,
              section: 'EventPage',
          }),
          ':',
        ]);

      case 5:
        return h('div', { class: 'notification__title' }, [
          'Event ',
          h(NotificationLink, {
              linkData: this.notificationData.model.event,
              section: 'EventPage',
          }),
          ' changed',
        ]);

      case 6:
        return h('div', { class: 'notification__title' }, [
          'Event ',
          h(NotificationLink, {
              linkData: this.notificationData.model.event,
              section: 'EventPage',
          }),
          ' canceled',
        ]);

      case 7:
        return h('div', { class: 'notification__title' }, [
          'Event invitation canceled ',
        ]);

      case 8:
        return h('div', { class: 'notification__title' }, [
          h(
            'router-link',
            {
              class: 'notification-link',
              to: { name: 'Invitations', query: { tab: 'teams' } },
            },
            'New invitation ',
          ),
          ' to the team',
          h(NotificationLink, {
              linkData: this.notificationData.model.team,
              section: 'TeamPage',
          }),
        ]);

      case 9:
        return h('div', { class: 'notification__title' }, [
          'New message from team ',
          h(NotificationLink, {
              linkData: this.notificationData.model.team,
              section: 'TeamPage',
          }),
          ':',
        ]);

      case 10:
        return h('div', { class: 'notification__title' }, [
          'New message to the event ',
          h(NotificationLink, {
              linkData: this.notificationData.model.event,
              section: 'EventPage',
          }),
          ' from ',
          h(NotificationLink, {
              linkData: this.notificationData.model.user,
              section: 'UserProfile',
          }),
          ':',
        ]);

      case 11:
        return h('div', { class: 'notification__title' }, [
          'New message from: ',
          this.createLink(this.notificationData?.model?.user, 'UserProfile'),
        ]);
    }
  },
  methods: {
    // Utility method to create NotificationLink with fallback handling
    createLink(linkData, section) {
      console.log('createLink:', linkData, section);
      if (!linkData) {
        return h('span', {}, 'Unknown');
      }
      return h(NotificationLink, { linkData, section });
    },
}
});

export default NotificationPreviewTitle;
